import { Chosen } from '@harvesthq/porchlight'

import { useEffect, useMemo, useState } from 'preact/compat'

export const TaskSelect = ({
  onSelect,
  onChosenEvent,
  defaultTaskId,
  projectId,
  tasks,
}) => {
  const [selectedTask, setSelectedTask] = useState()

  const groups = useMemo(
    () =>
      tasks?.reduce(
        (groups, { billable, id, name }) => {
          const group = groups.find(
            (group) => group.name === (billable ? 'Billable' : 'Non-Billable')
          )

          const choice = {
            text: name,
            value: id,
            'data-analytics-element-id': 'project-choice',
            'data-analytics-project-id': id,
          }

          group?.choices.push(choice)
          return groups
        },
        [
          { name: 'Billable', choices: [] },
          { name: 'Non-Billable', choices: [] },
        ]
      ),
    [tasks]
  )

  const onChange = (value) => {
    if (value) {
      setSelectedTask(+value)
    }
  }

  useEffect(() => {
    if (!tasks?.length) return
    if (!groups?.length) return
    if (selectedTask !== undefined) return

    if (defaultTaskId) {
      const taskId = tasks.find(({ id }) => id === defaultTaskId)?.id
      setSelectedTask(taskId || groups[0].choices[0]?.value || tasks[0].id)
    } else {
      setSelectedTask(groups[0].choices[0]?.value || tasks[0].id)
    }
  }, [selectedTask, defaultTaskId, tasks, groups])

  useEffect(() => {
    onSelect(selectedTask)
  }, [onSelect, selectedTask])

  if (!projectId || !tasks?.length) {
    return (
      <div className="pds-mb-sm">
        <Chosen disabled choices={[]} placeholder="Select a task" select />
      </div>
    )
  }

  return (
    <div className="pds-mb-sm">
      <Chosen
        required
        choices={groups || []}
        placeholder="Select a task"
        name="task_id"
        select
        onChange={onChange}
        onClose={onChosenEvent}
        onOpen={onChosenEvent}
        value={selectedTask}
        data-analytics-element-id="task-select"
      />
    </div>
  )
}
